import { Component, Input } from "@angular/core";
import {MatBottomSheetRef} from '@angular/material/bottom-sheet';

@Component({
    selector: 'theermanam-selection-sheet-sheet',
    templateUrl: './theermanam-selection-sheet.component.html',
    styleUrls: ['./theermanam-selection-sheet.component.scss'],
  })
  export class TheermanamSelectionSheet {
   @Input() events: any;
   selectedEventId:number;
    public callbacks = {
      onOkClick: (eventId:number) => {},
      onCancelClick: () => {}
    }
    constructor(private _bottomSheetRef: MatBottomSheetRef<TheermanamSelectionSheet>) {
      this.selectedEventId = null
    }

    onDropdownChange() {

    }

    onCancelClick() {
      this.callbacks.onCancelClick();
      this._bottomSheetRef.dismiss();
    }

    onOkClick() {
      this.callbacks.onOkClick(this.selectedEventId)
      this._bottomSheetRef.dismiss();
      location.reload();
    }

    disableSaveBtn(): boolean {
      return !this.selectedEventId
    }
   }